export const eventCategoriesPath = '/management_panel/event_categories'

export const editEventCategoryPath = ({ categoryId }) =>
  `${eventCategoriesPath}/${categoryId}/edit`

export const newEventCategoryPath = '/management_panel/event_categories/new'
